<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
                <m-search-item label="售后工单">
                    <c-input name="business_number" placeholder="请输入工单号"></c-input>
                </m-search-item>
                <m-search-item label="操作时间" colspan="2">
                    <c-datetime start-name="start_date" end-name="end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
                </m-search-item>
                <m-search-item label="操作类型">
                    <c-select name="operation_types" :options="ordrOperationOptions" multiple ></c-select>
                </m-search-item>
			</m-search>
            <c-table ref="list" height="grow">
                <c-table-column
                        label="操作时间"
                        name="create_date"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="操作用户"
                        name="create_user_realname"
                        width="120"
                >
                    <template #default="{data}">
                        <span v-if="data.create_user_realname">{{data.create_user_realname}}</span>
                        <span v-else>系统自动</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="售后工单"
                        name="business_number"
                        width="120"
                >
                    <template #default="{data}">
                        <c-link v-if="auth('b_aftersale_order_query')" @click="globalDialog('afterSaleOrderDetail', {props: {id: data.work_id}})">{{data.business_number}}</c-link>
                        <span v-else>{{data.business_number}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="操作类型"
                        name="operation_type"
                        width="70"
                >
                    <template #default="{data}">
                        <c-state dict="operationName" :value="data.operation_type"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="操作详情"
                        width="400"
                        :ellipsis="false"
                >
                    <template #default="{data}">
                        <span>{{data.remark}}</span>
                        <c-link v-if="auth('b_aftersale_order_dispatch_log') && data.operation_type==29 && data.dispatch_id"
                                @click="globalDialog('afterSaleOrderDispatchLog', {props: {id: data.work_id,dispatch_id:data.dispatch_id}})">派单日志</c-link>
                        <c-link v-else-if="data.data_list && data.data_list.length > 0" :ref="`detail${data.id}`" @click="detailHandle(data)">查看详细数据</c-link>
                        <span v-else-if="data.operation_type==2 && (!data.data_list || data.data_list.length==0)">，未修改任何数据</span>
                        <span v-else>&nbsp;</span>
                    </template>
                </c-table-column>
            </c-table>

            <c-window ref="window" title="详细数据" align="end" height="240">
                <ul class="logs-list">
                    <li v-for="(item, i) in detailData" :key="i">{{item}}</li>
                </ul>
            </c-window>
		</module>
	</page>
</template>

<script>
export default {
	name: 'm_dispatch_logs',

	data() {
		return {
            workType:2,
            operationTypes:[20,21,22,29],
            ordrOperationOptions:[
                {name: '自动派单', value: 29, color: 'blue'},
                {name: '手动派单', value: 21, color: 'blue'},
                {name: '取消派单', value: 20, color: 'red'},
                {name: '拒单', value: 22, color: 'brown'}
            ],
            detailData: []
        };
	},

	mounted() {
		this.searchHandle();
	},

	methods: {
        searchHandle(data){
            if (!data){
                data = {};
            }
            if (!data.operation_types || data.operation_types.length == 0){
                data.operation_types = this.operationTypes;
            }
            data.work_type_id = this.workType;
            this.$refs.list.load({
                url: '/sys/work/log/list',
                data,
                dataFormatter: data => {
                    data.forEach(item => {
                        if (!item.data_json||item.data_json.length==0) return;
                        if (item.operation_type == 2) {
                            item.data_list = item.data_json.map(item => {
                                return `【${item.字段}】: 【${item.原值 || '空'}】 → 【${item.新值 || '空'}】`;
                            });
                        } else {
                            item.data_list = item.data_json.map(item => {
                                let key = Object.keys(item)[0];
                                return `${key}：${item[key]}`;
                            });
                        }
                    });
                    return data;
                }
            });
        },

        detailHandle(data) {
            this.detailData = data.data_list;
            this.$refs.window.show(this.$refs[`detail${data.id}`]);
        }
	}
};
</script>

<style lang="stylus" scoped>
.logs-list {
    padding: 10px 10px;

    li {
        padding: 4px 0;
        line-height: 16px;
        font-size: 13px;
        color: #666;
    }
}
</style>
